export default {
  path: "/administrator",
  component: () => import("@/layouts/main.vue"),
  redirect: { name: "referensi", params: { ref: "ref_jenis_rumah_atau_bangunan" } },
  meta: {
    authRequired: true,
    verificationRequired: true,
    roles : ["administrator"]
  },
  children: [
    {
      path: "ref-wilayah",
      name: "ref-wilayah",
      meta: {
        title: "Referensi Wilayah",
        authRequired: true,
        roles: ["administrator"],
      },
      component: () => import("../views/custom/administrator/referensi/ref-wilayah/index.vue"),
    },
    {
      path: "ref-jenis-dokumen",
      name: "ref-jenis-dokumen",
      meta: {
        title: "Referensi Jenis Dokumen",
        authRequired: true,
        roles: ["administrator"],
      },
      component: () => import("../views/custom/administrator/referensi/ref-jenis-dokumen/index.vue"),
    },
     {
      path: "ref-jenis-dokumen",
      name: "ref-jenis-dokumen",
      meta: {
        title: "Referensi Jenis Dokumen",
        authRequired: true,
        roles: ["administrator"],
      },
      component: () => import("../views/custom/administrator/referensi/ref-jenis-dokumen/index.vue"),
    },
     {
      path: "ref-jenis-dokumen/create",
      name: "ref-jenis-dokumen-create",
      meta: {
        title: "Referensi Jenis Dokumen",
        authRequired: true,
        roles: ["administrator"],
      },
      component: () => import("../views/custom/administrator/referensi/ref-jenis-dokumen/create.vue"),
    },
     {
      path: "ref-jenis-dokumen/edit/:id",
      name: "ref-jenis-dokumen-edit",
      meta: {
        title: "Referensi Jenis Dokumen",
        authRequired: true,
        roles: ["administrator"],
      },
      component: () => import("../views/custom/administrator/referensi/ref-jenis-dokumen/update.vue"),
    },
    {
      path: ":ref",
      name: "referensi",
      meta: {
        title: "Referensi",
        authRequired: true,
      },
      component: () => import("../views/custom/administrator/referensi/index.vue"),
    },
    {
      path: ":ref/create",
      name: "referensi-create",
      meta: {
        title: "Referensi",
        authRequired: true,
      },
      component: () => import("../views/custom/administrator/referensi/create.vue"),
    },
    {
      path: ":ref/update/:id",
      name: "referensi-update",
      meta: {
        title: "Referensi",
        authRequired: true,
      },
      component: () => import("../views/custom/administrator/referensi/update.vue"),
    },
    {
      path: "pertanyaan",
      name: "pertanyaan",
      meta: {
        title: "Manajemen Pertanyaan",
        authRequired: true,
      },
      component: () => import("../views/custom/administrator/pertanyaan/index.vue"),
    },
    {
      path: "pertanyaan/create",
      name: "pertanyaan-create",
      meta: {
        title: "Buat Pertanyaan",
        authRequired: true,
      },
      component: () => import("../views/custom/administrator/pertanyaan/create.vue"),
    },
    {
      path: "pertanyaan/update/:id",
      name: "pertanyaan-update",
      meta: {
        title: "Edit Pertanyaan",
        authRequired: true,
      },
      component: () => import("../views/custom/administrator/pertanyaan/update.vue"),
    },
    {
      path: "pertanyaan/:id/opsi",
      name: "pertanyaan-opsi",
      meta: {
        title: "Manajemen Opsi Pertanyaan",
        authRequired: true,
      },
      component: () => import("../views/custom/administrator/pertanyaan/detail/index.vue"),
    },
    {
      path: "pertanyaan/:id/opsi/create",
      name: "pertanyaan-opsi-create",
      meta: {
        title: "Buat Opsi Pertanyaan",
        authRequired: true,
      },
      component: () => import("../views/custom/administrator/pertanyaan/detail/create.vue"),
    },
    {
      path: "pertanyaan/:id/opsi/update/:opsiId",
      name: "pertanyaan-opsi-update",
      meta: {
        title: "Edit Opsi Pertanyaan",
        authRequired: true,
      },
      component: () => import("../views/custom/administrator/pertanyaan/detail/update.vue"),
    },
    {
      path: "manajemen-user",
      name: "manajemen-user",
      meta: {
        title: "Manajemen User",
        authRequired: true,
        roles: ["administrator"],
      },
      component: () => import("../views/custom/administrator/manajemen-user.vue"),
    },
    {
      path: "master-cpb",
      name: "master-cpb",
      meta: {
        title: "Master CPB",
        authRequired: true,
      },
      component: () => import("../views/custom/administrator/master/cpb.vue"),
    },
    {
      path: "master-cpb/update/:id",
      name: "master-cpb-update",
      meta: {
        title: "Edit Master CPB",
        authRequired: true,
      },
      component: () => import("../views/custom/administrator/master/cpb-edit.vue"),
    },
    {
      path: "master-periksa-kualitas",
      name: "master-periksa-kualitas",
      meta: {
        title: "Master Periksa Kualitas",
        authRequired: true,
      },
      component: () => import("../views/custom/administrator/master/periksa-kualitas.vue"),
    },
    {
      path: "master-periksa-kualitas/update/:id",
      name: "master-periksa-kualitas-update",
      meta: {
        title: "Edit Master Periksa Kualitas",
        authRequired: true,
      },
      component: () => import("../views/custom/administrator/master/periksa-kualitas-edit.vue"),
    },
  ],
};
